export default __webpack_public_path__ + "static/media/titolohome.c280880b.png";